import { Box, styled } from "@mui/material";

export const CellWrapper = styled(Box)`
  display: flex;
  height: 100%;
  width: 24px;
  justify-content: center;
  align-items: center;
`;
